module.exports = __webpack_public_path__ + "static/koi-76102d454d560b9a6e4fc7e039699a9e.mp4";